<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>DECOLONIZING THE MAP</h1>
<h1 class="bk1">CARTOGRAPHY FROM COLONY TO NATION</h1>
<p class="bkau">EDITED BY JAMES R. AKERMAN</p>
<p class="bkpub">THE UNIVERSITY OF CHICAGO PRESS</p>
<p class="bkpub1">Chicago and London</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Akerman-0004.vue?c3b2e508